import { ProductCardProps } from '@teko/ecommerce';
import { getProductWithBestPrice, ProductHelper } from '../../../../../helpers';
import slug from '@teko/slug';
import { DiscoveryProduct } from 'types';

export const convertProductCardFn = (product: any): ProductCardProps => {
  return getProductWithBestPrice(product);
};
export class PhongVuProductHelper extends ProductHelper {
  constructor(milestoneShippingFee = null) {
    super(milestoneShippingFee);
  }
  getLinkProduct(product: DiscoveryProduct, skuVariant?: string): string {
    const { productInfo } = product;
    let sku = productInfo.sku;
    if (skuVariant) {
      sku = skuVariant;
    }
    return productInfo.slug
      ? `/${productInfo.slug}-s${sku}.html`
      : `/${slug(productInfo.name)}-s${sku}.html`;
  }
}
